import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var DropboxSvg = function DropboxSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 6.107 7.578 3 2 6.92l4.422 3.109L2 13.137l5.578 3.921L12 13.95l4.422 3.108L22 13.137l-4.422-3.108L22 6.92 16.422 3zm0 1.626 3.265 2.296L12 12.324l-3.265-2.295zm4.422 3.109-3.265 2.295 3.265 2.295 3.265-2.295zM10.843 6.92 7.578 4.625 4.313 6.92l3.265 2.296zm5.579 2.296L13.157 6.92l3.265-2.295 3.265 2.295zm-8.844 1.626 3.265 2.295-3.265 2.295-3.265-2.295z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.25 18.511 12 21.5l-4.25-2.987.761-1.091 3.49 2.452 3.488-2.453z"
  }));
};
export var Dropbox = function Dropbox(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: DropboxSvg
  }));
};